document.addEventListener('DOMContentLoaded', function() {
  let productsSwiper;

  function updateProductsGrid(index) {
    const productGrids = document.querySelectorAll('.section-look-slider .products-grid');
    productGrids.forEach(grid => {
      grid.style.transition = 'opacity 0.3s ease-in-out';
      grid.classList.remove('active');
    });
    
    requestAnimationFrame(() => {
      const activeGrid = document.querySelector(`.section-look-slider .products-grid[data-slide-products="${index}"]`);
      if (activeGrid) {
        activeGrid.classList.add('active');
      }
    });
  }

  function updateMobileSlides(index) {
    const slides = document.querySelectorAll('.section-look-slider .products-swiper .swiper-slide');
    slides.forEach(slide => {
      if (slide.dataset.slideProducts === index.toString()) {
        slide.style.display = '';
      } else {
        slide.style.display = 'none';
      }
    });
    if (productsSwiper) {
      productsSwiper.update();
      productsSwiper.slideTo(0);
    }
  }

  // Products swiper for mobile
  productsSwiper = new Swiper('.section-look-slider .products-swiper .swiper', {
    slidesPerView: 2,
    spaceBetween: 2,
    grid: {
      fill: 'row',
      rows: 1
    },
    navigation: {
      nextEl: '.section-look-slider .products-swiper .swiper-button-next',
      prevEl: '.section-look-slider .products-swiper .swiper-button-prev'
    }
  });

  // Main look slider
  const lookSwiper = new Swiper('.section-look-slider .look-slider-container .swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    speed: 300,
    navigation: {
      nextEl: '.section-look-slider .look-slider-container .swiper-button-next',
      prevEl: '.section-look-slider .look-slider-container .swiper-button-prev',
    },
    on: {
      init: function() {
        updateProductsGrid(this.realIndex);
        updateMobileSlides(this.realIndex);
      },
      slideChange: function() {
        updateProductsGrid(this.realIndex);
        updateMobileSlides(this.realIndex);
      }
    }
  });
}); 